import React, { useContext } from "react";
import { Card, Badge } from "react-bootstrap";
import { LanguageContext } from "../../context/LanguageContext";

export default function FavoriteProductCard({ product }) {
  const { language } = useContext(LanguageContext);

  return (
    <Card className="product-card border-0 shadow-lg rounded-4 w-100 h-100">
      <div className="position-relative">
        <Card.Img
          variant="top"
          src={product.image}
          alt={product.name[language]}
          style={{
            height: "200px",
            objectFit: "cover",
            borderTopLeftRadius: "1rem",
            borderTopRightRadius: "1rem",
          }}
        />

        <Badge
          bg={product.stock > 0 ? "success" : "danger"}
          className="position-absolute top-0 end-0 m-2 px-3 py-2 fs-6 rounded-pill shadow"
        ></Badge>
      </div>

      <Card.Body className="p-4">
        <Card.Title className="fw-bold fs-5 text-primary">
          {product.name[language]}
        </Card.Title>
        <Card.Text className="text-muted small">
          {product.description[language]}
        </Card.Text>
      </Card.Body>
    </Card>
  );
}
